import { FunctionComponent, ReactNode } from "react";
import SignUpPicture from "../../assets/images/signUp.svg";

type Props = {
  children: ReactNode;
};

const ImageSideContainer: FunctionComponent<Props> = ({ children }) => {
  return (
    <>
      <section className="signUp_section">
        <div className="signUp_container">{children}</div>
        <img src={SignUpPicture} alt="" className="signUp_img" />
      </section>
    </>
  );
};

export default ImageSideContainer;
